import {defineStore} from 'pinia';
import {BaseStore} from '@/stores/baseStore';
import {ModuleNotification} from '../moduleConst';
import api from '@/apis/other/notificationApi';
import {MSConstant} from '@/commons/wildcards/index.js';
import NotificationType from '@/commons/wildcards/constants/NotificationType.js';
import NotificationDetailType from '@/commons/wildcards/constants/NotificationDetailType.js';
import i18nBaseForm from '@/i18ns/vi/i18nBaseForm';
import {useContextStore} from '../contextStore';
import commonFn from '@/commons/commonFunction';
import { msFormat } from '@/commons/msFormat';

/**
 * Store thông báo
 * ndhieu3 25.09.2023
 */
const notificationStore = new BaseStore(api);
export const useNotificationStore = defineStore(ModuleNotification, {
  state: () => ({
    ...notificationStore.state,
    _config: {key: 'notification_id', name: 'data', table: 'notification', moduleName: 'Thông báo'},
    moduleName: 'notification',
    unread: 0,
    isBellRing: false,
  }),
  actions: {
    ...notificationStore.action,
    /**
     * Lấy dữ liệu thông báo mới nhất
     * ndhieu3 25.09.2023
     */
    async getNewestNoti() {
      let res = null;
      try {
        res = await api.getNewestNoti();
        return res;
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * Lấy dữ liệu thông báo
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async getData(payload) {
      const param = genPayloadGetNoti(payload, false);
      let data = await api.getAllNotification(param || {});
      let res = data?.Data || [];

      customNotification(res);

      return {
        res: res,
        data: data,
      };
    },

    /**
     * Cập nhật đã đọc
     * @param {*} context
     * @param {*} id
     * @returns
     */
    async updateRead(item) {
      let res = null;
      let id = item.notification_id;

      try {
        res = await api.updateRead(id);
      } catch (error) {}
    },

    /**
     * Lấy thông báo chưa đọc
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async getUnreadNotification(payload, ringBell) {
      let res = null;

      payload = payload || {
        user_id: useContextStore().CurUserId,
        noticeType: MSConstant.NoticeType.None,
        readed: false,
        skip: 0,
        take: 0,
      };

      const param = genPayloadGetNoti(payload, true);

      try {
        let data = await api.getUnreadNotification(param || {});
        res = data?.Unread || 0;

        // Cập nhật số lượng thông báo chưa đọc
        this.unread = res;

        // Có rung chuông thông báo hay ko
        this.isBellRing = ringBell && res > 0;
      } catch (error) {}

      return res;
    },
  },
  getters: {
    ...notificationStore.getters,
  },
});

/**
 * Lấy tham số để gọi lấy dữ liệu ds thông báo
 * @param {*} payload
 * @param {*} isGetNumber
 * @returns
 */
function genPayloadGetNoti(payload, isGetNumber) {
  payload = payload || {};
  return {
    in_notify_type: getFilterPayload(payload),
    user_id: payload.user_id,
    status: payload.readed == null ? -1 : payload.readed ? 1 : 0,
    skip: payload.skip,
    take: payload.take,
    get_number: isGetNumber,
  };
}

/**
 * Lọc thông báo theo loại
 * @returns
 */
function getFilterPayload(payload) {
  var def = [];

  switch (payload?.noticeType || MSConstant.NoticeType.None) {
    case MSConstant.NoticeType.Action:
      def = [
        MSConstant.NotificationType.PostBath,
        MSConstant.NotificationType.ChangeDatabaseName,
        MSConstant.NotificationType.DeletingDatabase,
        MSConstant.NotificationType.EndDeleteDatabase,
        MSConstant.NotificationType.CreatingData,
        MSConstant.NotificationType.EndCreateData,
        MSConstant.NotificationType.System,
        MSConstant.NotificationType.BackupDataCompleted,
        MSConstant.NotificationType.RestoreDataCompleted,
      ];
      break;
    case MSConstant.NoticeType.Promotion:
      def = [
        /** Khuyến mại */
        MSConstant.NotificationType.Promotion,
      ];
      break;
    case MSConstant.NoticeType.None:
    default:
      def = [
        MSConstant.NotificationType.PostBath,
        MSConstant.NotificationType.Promotion,
        MSConstant.NotificationType.ChangeDatabaseName,
        MSConstant.NotificationType.DeletingDatabase,
        MSConstant.NotificationType.EndDeleteDatabase,
        MSConstant.NotificationType.CreatingData,
        MSConstant.NotificationType.EndCreateData,
        MSConstant.NotificationType.System,
        MSConstant.NotificationType.BackupDataCompleted,
        MSConstant.NotificationType.RestoreDataCompleted,
        MSConstant.NotificationType.SubmitReport,
        MSConstant.NotificationType.RetrieveReport,
        MSConstant.NotificationType.RequireSubmitReport,
        MSConstant.NotificationType.AprroveReport,
        MSConstant.NotificationType.RejectReport,
      ];
      break;
  }

  return def.join(';');
}

/**
 * Custom thông báo
 */
function customNotification(arr) {
  arr.forEach(item => {
    if (item.data) {
      item.targetData = JSON.parse(item.data);
      var clickError = 'Bấm vào đây để';
      switch (item.type) {
        // Đổi tên dữ liệu
        case NotificationType.ChangeDatabaseName:
          item.text = `<b>Đã hoàn thành</b> đổi tên dữ liệu <b>${commonFn.processXssValue(
            item.targetData.old_database_name,
          )}</b> thành <b>${commonFn.processXssValue(item.targetData.database_name)}</b>.`;
          break;
        // Đang xóa dữ liệu
        case NotificationType.DeletingDatabase:
          item.text = `<b>Đang thực hiện</b> xóa dữ liệu. Vui lòng chờ trong giây lát.`;
          break;
        // Xóa dữ liệu thành công
        case NotificationType.EndDeleteDatabase:
          item.text = `<b>Đã hoàn thành</b> xóa dữ liệu <b>${commonFn.processXssValue(
            item.targetData.database_name,
          )}</b>.`;
          break;
        /** Ghi sổ bỏ ghi theo lô */
        case NotificationType.PostBath:
          var {status, type} = item.targetData;
          type = commonFn.processXssValue(
            type == NotificationDetailType.PostBath.Type.UnPost ? 'bỏ ghi sổ theo lô' : 'ghi sổ theo lô',
          );
          var txt =
            status == NotificationDetailType.PostBath.Status.Start
              ? `<b>Đang thực hiện</b> ${type}. Vui lòng chờ trong giây lát.`
              : `<b>Đã hoàn thành</b> ${type}.`;

          if (status == NotificationDetailType.PostBath.Status.Complete && item.targetData.number_error) {
            txt += ' ' + i18nBaseForm.Notification.ErrorMes.format(type);
          }

          item.text = txt;
          break;
        case NotificationType.CreatingData:
          item.text = `<b>Đang thực hiện</b> thêm mới dữ liệu. Vui lòng chờ trong giây lát.`;
          break;
        case NotificationType.EndCreateData:
          item.text = `<b>Đã hoàn thành</b> thêm mới dữ liệu <b>${commonFn.processXssValue(
            item.targetData.database_name,
          )}</b>.`;
          break;
        case NotificationType.ErrorCreateData:
          item.text =
            i18nBaseForm.Notification.ErrorCreateData +
            `<b>${commonFn.processXssValue(item.targetData.database_name)}</b>`;
          break;
        case NotificationType.System:
        case NotificationType.Promotion:
          item.title = item.targetData.title;
          item.text = item.targetData.content;
          item.link = item.targetData.button_name ? '' : item.targetData.button_link;

          break;
        case NotificationType.BackupDataCompleted:
          if (item.targetData.status == MSConstant.BackupDataStatus.BackupSuccessful) {
            item.text = `<b class="color-green">Đã hoàn thành</b> sao lưu <b>${commonFn.processXssValue(
              item.targetData.backup_name,
            )}</b>`;
          } else if (item.targetData.status == MSConstant.BackupDataStatus.BackupFailed) {
            item.text = `Sao lưu <b>${commonFn.processXssValue(
              item.targetData.backup_name,
            )}</b> không thành công. Vui lòng liên hệ MISA để được hỗ trợ.`;
          }
          break;
        case NotificationType.RestoreDataCompleted:
          if (item.targetData.status == MSConstant.RestoreDataStatus.RestoreSuccess) {
            item.text = `<b class="color-green">Đã hoàn thành</b> phục hồi <b>${commonFn.processXssValue(
              item.targetData.restore_name,
            )}</b>. `;
            item.link1 = {
              text: 'Mở dữ liệu',
              code: 'ChangeDatabaseUse',
              data: item.targetData,
            };
          } else if (item.targetData.status == MSConstant.RestoreDataStatus.RestoreError) {
            item.text = `Khôi phục dữ liệu <b>${commonFn.processXssValue(
              item.targetData.restore_name,
            )}</b> không thành công. Vui lòng liên hệ MISA để được hỗ trợ`;
          }
          break;
        case NotificationType.SubmitReport:
          var child_tenant_name = commonFn.processXssValue(item.targetData.child_tenant_name);
          var period_text = commonFn.getEnumResource(item.targetData.period, 'PeriodReport');
          period_text = commonFn.processXssValue(period_text);
          var year_text = commonFn.processXssValue(item.targetData.year);
          item.text = `${child_tenant_name} đã nộp báo cáo kỳ ${period_text} năm ${year_text}`;
          break;
        case NotificationType.RequireSubmitReport:
          var child_tenant_name = commonFn.processXssValue(item.targetData.child_tenant_name);
          var period_text = commonFn.getEnumResource(item.targetData.period, 'PeriodReport');
          period_text = commonFn.processXssValue(period_text);
          var year_text = commonFn.processXssValue(item.targetData.year);
          var deadline = msFormat.formatDate(commonFn.processXssValue(item.targetData.deadline));
          item.text = `${child_tenant_name} yêu cầu nộp báo cáo kỳ ${period_text} năm ${year_text} trước ngày ${deadline}`;
          
          // Thêm nội dung mô tả nếu có
          if (item.targetData.description) {
            var description = commonFn.processXssValue(item.targetData.description);
            item.text += `<br><b>Nội dung:</b> ${description}`;
          }
          break;
        case NotificationType.AprroveReport:
          var child_tenant_name = commonFn.processXssValue(item.targetData.child_tenant_name);
          var period_text = commonFn.getEnumResource(item.targetData.period, 'PeriodReport');
          period_text = commonFn.processXssValue(period_text);
          var year_text = commonFn.processXssValue(item.targetData.year);
          item.text = `${child_tenant_name} đã nhận báo cáo kỳ ${period_text} năm ${year_text}`;
          break;
        case NotificationType.RejectReport:
          var child_tenant_name = commonFn.processXssValue(item.targetData.child_tenant_name);
          var period_text = commonFn.getEnumResource(item.targetData.period, 'PeriodReport');
          period_text = commonFn.processXssValue(period_text);
          var year_text = commonFn.processXssValue(item.targetData.year);
          var description = commonFn.processXssValue(item.targetData.description);
          var deadline = msFormat.formatDate(commonFn.processXssValue(item.targetData.deadline));
          item.text = `${child_tenant_name} gửi trả báo cáo kỳ ${period_text} năm ${year_text} <br><b>Thời hạn nộp:</b> ${deadline} <br><b>Lý do:</b> ${description}`;
          break;
        case NotificationType.RetrieveReport:
          var child_tenant_name = commonFn.processXssValue(item.targetData.child_tenant_name);
          var period_text = commonFn.getEnumResource(item.targetData.period, 'PeriodReport');
          period_text = commonFn.processXssValue(period_text);
          var year_text = commonFn.processXssValue(item.targetData.year);
          item.text = `${child_tenant_name} đã thu hồi cáo kỳ ${period_text} năm ${year_text}`;
          break;
      }
    }
  });
}
